export default {
  path: '/reports/overview/:name',
  name: 'ReportsDataOverview',
  component: () => import(/* webpackChunkName: "base" */ '../views/ReportView.vue')
}
